import { Row, Col } from 'antd'
import { setPriceTypeFilter } from '../../../Slices/Kiosk/PriceSlice'
import { renderTranslation, getCurrencyConversion, getCurrencySymbolByPricelist } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { PriceType, PriceTypeShow } from '../../../Constants/TableConfiguration'
import { VariantModelValue } from '../../../Constants/Configuration'
import { useAppDispatch, useAppSelector } from '../../../hooks'

/**
 * @param {any} priceTypeFilter;
 * @param {any} sellAndPurchaseValue;
 */

export default function PricesHeader(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const priceList1 = useAppSelector(state => state.present.tableOptions.priceList1)
  return (
    <Col span={props.priceTypeShow === PriceTypeShow.history ? 16 : 24}>
      <Row className={!props.isBySize && props.priceTypeShow === PriceTypeShow.omni ? 'omni-prices-table-header' : ''}>
        <Col
          span={props.isBySize ? (props.priceTypeShow === PriceTypeShow.history ? 12 : 8) : 24}
          className={
            !props.isBySize
              ? 'cursor-pointer purchase-button-filter-recap sale' +
                (props.priceTypeFilter.indexOf(PriceType.purchase) !== -1 ? ' active' : '')
              : 'purchase-button-filter-recap-size sale' +
                (PriceTypeShow.history === props.priceTypeShow ? ' bold' : '')
          }
          onClick={() => {
            if (props.isBySize) return
            dispatch(setPriceTypeFilter(PriceType.purchase))
          }}
        >
          <span className='purchase-button-text'>
            {renderTranslation(language, TranslationKeys.priceSectionTableFilterACQLabel)}
          </span>

          <span className='purchase-button-price'>
            {props.sellAndPurchaseValue.buyPrice
              ? getCurrencySymbolByPricelist(priceList1, VariantModelValue) +
                ' ' +
                getCurrencyConversion(props.sellAndPurchaseValue.buyPrice)
              : null}
          </span>
        </Col>
        <Col
          span={props.isBySize ? (props.priceTypeShow === PriceTypeShow.history ? 12 : 8) : 24}
          className={
            !props.isBySize
              ? 'cursor-pointer sell-button-filter-recap' +
                (props.priceTypeFilter.indexOf(PriceType.sell) !== -1 ? ' active' : '')
              : 'sell-button-filter-recap-size' + (PriceTypeShow.history === props.priceTypeShow ? ' bold' : '')
          }
          onClick={() => {
            if (props.isBySize) return
            dispatch(setPriceTypeFilter(PriceType.sell))
          }}
        >
          <span className='sell-button-text'>
            {renderTranslation(language, TranslationKeys.priceSectionTableFilterVENLabel)}
          </span>

          <span className='sell-button-price'>
            {props.sellAndPurchaseValue.sellPrice
              ? getCurrencySymbolByPricelist(priceList1, VariantModelValue) +
                ' ' +
                getCurrencyConversion(props.sellAndPurchaseValue.sellPrice)
              : null}
          </span>
        </Col>
        {props.isBySize && PriceTypeShow.history !== props.priceTypeShow ? (
          <Col className={'size-filter-recap'} span={props.isBySize ? 8 : null}>
            <span>{renderTranslation(language, TranslationKeys.priceSectionTableFilterTAGLabel)}</span>
          </Col>
        ) : null}
      </Row>
    </Col>
  )
}
